module.exports = __webpack_public_path__ + "b79b7ae8d9aeefe040d49af98f5169b2.png";